import React, { useState } from 'react';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';
import { parseImages } from '../../utils/utils';

/**
 * Componente reutilizável de miniatura de produto/serviço para o PDV
 * com suporte a fallback elegante para itens sem imagem cadastrada ou falhas de carregamento.
 */
const POSItemThumbnail = ({
  images,
  name = '',
  typeItem = 'product',
  size = 42,
  isDarkMode = false,
  style = {},
}) => {
  const [imgError, setImgError] = useState(false);

  // Extrai a primeira imagem válida
  const parsedList = parseImages(images);
  const rawImageUrl =
    Array.isArray(parsedList) && parsedList.length > 0 && typeof parsedList[0] === 'string'
      ? parsedList[0].trim()
      : null;

  const hasValidImage = Boolean(rawImageUrl && !imgError);

  const containerStyle = {
    width: style?.width || size,
    height: style?.height || size,
    minWidth: typeof size === 'number' && !style?.width ? size : undefined,
    minHeight: typeof size === 'number' && !style?.height ? size : undefined,
    maxWidth: typeof size === 'number' && !style?.width ? size : undefined,
    maxHeight: typeof size === 'number' && !style?.height ? size : undefined,
    borderRadius: 6,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: isDarkMode ? '#1e293b' : '#f1f5f9',
    border: isDarkMode ? '1px solid #334155' : '1px solid #e2e8f0',
    position: 'relative',
    userSelect: 'none',
    boxShadow: isDarkMode ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 2px rgba(0,0,0,0.06)',
    ...style,
  };

  if (hasValidImage) {
    return (
      <div style={containerStyle}>
        <img
          src={rawImageUrl}
          alt={name || 'Item'}
          loading="lazy"
          onError={() => setImgError(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>
    );
  }

  // Fallback visual para cadastros sem imagem
  const isService = typeItem === 'service';
  const iconColor = isDarkMode
    ? isService ? '#c084fc' : '#93c5fd'
    : isService ? '#7c3aed' : '#2563eb';

  const iconBg = isDarkMode
    ? isService ? 'rgba(192, 132, 252, 0.12)' : 'rgba(147, 197, 253, 0.12)'
    : isService ? 'rgba(124, 58, 237, 0.08)' : 'rgba(37, 99, 235, 0.08)';

  const iconFontSize = Math.max(16, Math.floor(size * 0.5));

  return (
    <div
      style={{
        ...containerStyle,
        backgroundColor: iconBg,
      }}
      title={name ? `${name} (Sem foto)` : 'Sem foto cadastrada'}
    >
      {isService ? (
        <BuildOutlinedIcon style={{ fontSize: iconFontSize, color: iconColor, opacity: 0.85 }} />
      ) : (
        <LocalMallOutlinedIcon style={{ fontSize: iconFontSize, color: iconColor, opacity: 0.85 }} />
      )}
    </div>
  );
};

export default POSItemThumbnail;
